import { useLang } from "@/providers/langProvider";

export const useRemoveLangFromPath = () => {
  const lang = useLang();
  const removeLangFromPath = (pathname: string, all = false) => {
    let currPath = pathname;
    const pathLang = "/" + lang;
    if (currPath.startsWith(pathLang))
      currPath = currPath.replace(pathLang, "");
    if (all) {
      currPath = currPath.replace("/ar", "").replace("/en", "");
    }
    if (currPath === "") currPath = "/";
    return currPath;
  };
  return removeLangFromPath;
};
